import { createReducer, on } from '@ngrx/store';

import { CheckInState } from '../../interfaces/store.interface';
import { CheckInActions, CheckInActionsUnion } from '../actions';

export const initialState: CheckInState = {
  passengers: [],
  boundId: undefined,
  clearPendingSeatsOnEntry: false,
  isModifyCheckIn: false,
};

const reducer = createReducer(
  initialState,
  on(CheckInActions.setPassengers, (state, { passengers }) => {
    return {
      ...state,
      passengers,
    };
  }),
  on(CheckInActions.setBoundId, (state, { boundId }) => {
    return {
      ...state,
      boundId,
    };
  }),
  on(CheckInActions.setClearPendingSeatsOnEntry, (state, { clearPendingSeatsOnEntry }) => {
    return {
      ...state,
      clearPendingSeatsOnEntry,
    };
  }),
  on(CheckInActions.setModifyCheckIn, (state, { isModifyCheckIn }) => {
    return {
      ...state,
      isModifyCheckIn,
    };
  })
);

export function checkInReducer(state: CheckInState, action: CheckInActionsUnion): CheckInState {
  return reducer(state, action);
}
